module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921061151_T.54582df0.jpg";